import React from "react";
import { useSalesPersons } from "../../hooks/usePersonsData";
import { useAssignWorkMutation } from "../../store/services/crmApi";
import { Work } from "../../store/types/work.types";
import AssignPersonDialog from "./AssignPersonDialog";

interface AssignWorkDialogProps {
  open: boolean;
  onClose: () => void;
  work: Work;
}

const AssignWorkDialog: React.FC<AssignWorkDialogProps> = ({
  open,
  onClose,
  work,
}) => {
  const { persons, isLoading } = useSalesPersons();
  const [assignWork] = useAssignWorkMutation();

  const handleAssign = async (personId: number | null) => {
    if (!personId) return;
    try {
      await assignWork({
        workId: work.Id,
        userId: personId,
      }).unwrap();
    } catch (error) {
      console.error("Error assigning work:", error);
      throw error;
    }
  };

  return (
    <AssignPersonDialog
      open={open}
      onClose={onClose}
      title="Tilldela ärende"
      label="Tilldela till"
      currentPersonId={work.AssignedTo?.Id}
      persons={persons}
      isLoading={isLoading}
      onAssign={handleAssign}
      allowClear={false}
    />
  );
};

export default AssignWorkDialog;
